import { adminUiEn, adminUiId } from '@bak/admin-ui'
import { aiEn, aiId } from './ai.js'
import { authEn, authId } from './auth.js'
import { blocksEn, blocksId } from './blocks.js'
import { commonEn, commonId } from './common.js'
import { contentEn, contentId } from './content.js'
import { dashboardEn, dashboardId } from './dashboard.js'
import { digicsEn, digicsId } from './digics.js'
import { domainsEn, domainsId } from './domains.js'
import { layoutEn, layoutId } from './layout.js'
import { leadsEn, leadsId } from './leads.js'
import { locationsEn, locationsId } from './locations.js'
import { livechatEn, livechatId } from './livechat.js'
import { mailboxEn, mailboxId } from './mailbox.js'
import { mediaEn, mediaId } from './media.js'
import { ordersEn, ordersId } from './orders.js'
import { paymentsEn, paymentsId } from './payments.js'
import { promosEn, promosId } from './promos.js'
import { planEn, planId } from './plan.js'
import { rolesEn, rolesId } from './roles.js'
import { sectionsEn, sectionsId } from './sections.js'
import { shopEn, shopId } from './shop.js'
import { siteEn, siteId } from './site.js'
import { subscriptionEn, subscriptionId } from './subscription.js'
import { typesEn, typesId } from './types.js'
import { usersEn, usersId } from './users.js'

// English is the source of truth: a key missing from a translation is a type error, not a runtime gap.
export const en = {
  ...commonEn,
  ...layoutEn,
  ...authEn,
  ...dashboardEn,
  ...contentEn,
  ...blocksEn,
  ...mediaEn,
  ...siteEn,
  ...planEn,
  ...subscriptionEn,
  ...domainsEn,
  ...sectionsEn,
  ...rolesEn,
  ...typesEn,
  ...leadsEn,
  ...mailboxEn,
  ...livechatEn,
  ...digicsEn,
  ...aiEn,
  ...locationsEn,
  ...shopEn,
  ...ordersEn,
  ...paymentsEn,
  ...promosEn,
  ...usersEn,
  ...adminUiEn,
} as const

export type MessageKey = keyof typeof en

export const id: Record<MessageKey, string> = {
  ...commonId,
  ...layoutId,
  ...authId,
  ...dashboardId,
  ...contentId,
  ...blocksId,
  ...mediaId,
  ...siteId,
  ...planId,
  ...subscriptionId,
  ...domainsId,
  ...sectionsId,
  ...rolesId,
  ...typesId,
  ...leadsId,
  ...mailboxId,
  ...livechatId,
  ...digicsId,
  ...aiId,
  ...locationsId,
  ...shopId,
  ...ordersId,
  ...paymentsId,
  ...promosId,
  ...usersId,
  ...adminUiId,
}
